import { inject, Injector, runInInjectionContext } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { initialNazioneState } from './nazione.state';
import { tapResponse } from '@ngrx/operators';
import { tap } from 'rxjs';
import { GetNazioneGQL } from '../../_graphql/generated';

export const NazioneStore = signalStore(
  { providedIn: 'root' },
  withState(initialNazioneState),

  withMethods((store, injector = inject(Injector)) => ({
    init: () =>
      runInInjectionContext(injector, () => {
        const getter = inject(GetNazioneGQL);

        return getter
          .fetch({}, { context: { headers: { 'x-hasura-role': 'anonymous' } } })
          .pipe(
            tap(() => patchState(store, { loading: true })),
            tapResponse({
              next: (res) => {
                patchState(store, {
                  loading: false,
                  lista: res.data?.unita_amministrativa_nazione,
                  failure: undefined,
                });
              },
              error: (error) => {
                patchState(store, {
                  loading: false,
                  failure: error,
                });
              },
            }),
          );
      }),
  })),
);
